import { render, staticRenderFns } from "./RegistrationBuilderList.vue?vue&type=template&id=31432988&scoped=true"
import script from "./RegistrationBuilderList.vue?vue&type=script&lang=js"
export * from "./RegistrationBuilderList.vue?vue&type=script&lang=js"
import style0 from "./RegistrationBuilderList.vue?vue&type=style&index=0&id=31432988&prod&scoped=true&lang=css"
import style1 from "./RegistrationBuilderList.vue?vue&type=style&index=1&id=31432988&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31432988",
  null
  
)

export default component.exports